export var CreditTransactionSource;
(function (CreditTransactionSource) {
    CreditTransactionSource["SubscriptionGrant"] = "SubscriptionGrant";
    CreditTransactionSource["SubscriptionRenewal"] = "SubscriptionRenewal";
    CreditTransactionSource["TopUpPurchase"] = "TopUpPurchase";
    CreditTransactionSource["TextGeneration"] = "TextGeneration";
    CreditTransactionSource["ImageGeneration"] = "ImageGeneration";
    CreditTransactionSource["VideoGeneration"] = "VideoGeneration";
    CreditTransactionSource["MonthlyExpiry"] = "MonthlyExpiry";
    CreditTransactionSource["AdminGrant"] = "AdminGrant";
    CreditTransactionSource["AdminRefund"] = "AdminRefund";
    CreditTransactionSource["AnnualBonus"] = "AnnualBonus";
    CreditTransactionSource["ReferralReward"] = "ReferralReward";
})(CreditTransactionSource || (CreditTransactionSource = {}));
//# sourceMappingURL=credit-transaction-source.const.js.map